import { useContext } from 'react';
import { Context } from '../store/GlobalContext';

export default function useGlobalState() {
  return useContext(Context);
}
